'use client';

import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useLocale } from 'next-intl';
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Image from 'next/image';

export default function Header() {
  const t = useTranslations('navigation');
  const locale = useLocale();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link href={`/${locale}`} className="flex-shrink-0">
            <Image
              src="/mylogo.svg"
              alt="OM Transport"
              width={250}
              height={100}
              className="w-auto h-8 sm:h-16"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link href={`/${locale}`} className="nav-link">
              {t('home')}
            </Link>
            <Link href={`/${locale}/about`} className="nav-link">
              {t('about')}
            </Link>
            <Link href={`/${locale}/services`} className="nav-link">
              {t('services')}
            </Link>
            <Link href={`/${locale}/contact`} className="nav-link">
              {t('contact')}
            </Link>

            {/* Language Switcher */}
            <div className="relative ml-4">
              <Link
                href={locale === 'az' ? '/ru' : '/az'}
                className="inline-flex items-center px-3 py-1 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-600 hover:text-white transition-colors"
              >
                {locale === 'az' ? 'RU' : 'AZ'}
              </Link>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 focus:outline-none"
          >
            <span className="sr-only">Open menu</span>
            {!isOpen ? (
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            ) : (
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            )}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t"
          >
            <div className="px-4 pt-2 pb-3 space-y-1">
              <Link
                href={`/${locale}`}
                className="mobile-nav-link"
                onClick={() => setIsOpen(false)}
              >
                {t('home')}
              </Link>
              <Link
                href={`/${locale}/about`}
                className="mobile-nav-link"
                onClick={() => setIsOpen(false)}
              >
                {t('about')}
              </Link>
              <Link
                href={`/${locale}/services`}
                className="mobile-nav-link"
                onClick={() => setIsOpen(false)}
              >
                {t('services')}
              </Link>
              <Link
                href={`/${locale}/contact`}
                className="mobile-nav-link"
                onClick={() => setIsOpen(false)}
              >
                {t('contact')}
              </Link>

              {/* Mobile Language Switcher */}
              <Link
                href={locale === 'az' ? '/ru' : '/az'}
                className="block w-full text-left px-4 py-2 text-base font-medium text-blue-600 hover:bg-blue-50 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                {locale === 'az' ? 'Русский' : 'Azərbaycan'}
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
